import moment from 'moment';

export class DateHandler {

  /**
   * return date in dd MMM yyyy format
   * possible to return hh:mm
   * possible to remove timezone offset to see the original source save time
   *
   * @param {string | Date} date
   * @param {boolean} withTime
   * @param {boolean} clearTimezone
   * @return {string}
   */
  public static toString(date: string | Date, withTime = false, clearTimezone = true, dateConfig = undefined) {
    const config = dateConfig ? dateConfig :
      {
        year: 'numeric',
        month: 'short',
        day: '2-digit',
      };
    date = date instanceof Date ? date : new Date(date);

    if (withTime) {
      config['hour'] = '2-digit';
      config['minute'] = '2-digit';
    }
    if (clearTimezone) {
      date = DateHandler.removeTimezone(date);
    }

    // remove extra LTR and RTL characters in IE11
    const dateString = date.toLocaleDateString('en-US', config).replace(/[^ -~]/g, '');
    const dateArray = dateString.split(' ');
    if (dateString.toLowerCase() === 'invalid date') {
      return null;
    } else {
      const secondItem = dateArray[1].split(',')[0];
      let value = 'invalid date';
      // handle separate browser parsing date (IE11,Chrome)
      if (secondItem.length === 2) {
        value = secondItem + ' ' + dateArray[0] + ' ' + dateArray[2];
        if (withTime && dateArray.length >= 3) { // we check if dateArray has time elements within him and withTime flag is true for add time
          value += dateArray[3];
        }
      }
      else {
        value =  dateArray[2] + ' ' + secondItem + ' ' + dateArray[0];
        if (withTime && dateArray.length >= 3) {
          value += dateArray[3];
        }
      }
      return value;
    }
  }

  public static toStringWithOptions(date: Date, dateConfig: Object, timeConfig: Object) {
    if (date instanceof Date) {
      return {
          date: this.toString(date, false, true, dateConfig),
          time: (date).toLocaleString(timeConfig['locale'], timeConfig)};
    }
    return null;
  }

  public static toUsStandardStrings(date: Date) {
      return this.toStringWithOptions(date, { year: 'numeric', month: 'short', day: '2-digit'},
        { locale: 'en-US', hour: 'numeric', hour12: true, minute: 'numeric'});
  }


  /**
   * override the date toISOString so it will be aligned to format 8601 including the user timezone
   * 2017-12-18T00:00:00+02:00
   * @Override
   */
  public static OverrideToISOString() {
    Date.prototype.toISOString = function () {
      const tzo = -this.getTimezoneOffset(),
        dif = tzo >= 0 ? '+' : '-',
        pad = function (num) {
          const norm = Math.floor(Math.abs(num));
          return (norm < 10 ? '0' : '') + norm;
        };
      return this.getFullYear() +
        '-' + pad(this.getMonth() + 1) +
        '-' + pad(this.getDate()) +
        'T' + pad(this.getHours()) +
        ':' + pad(this.getMinutes()) +
        ':' + pad(this.getSeconds()) +
        dif + pad(tzo / 60) +
        ':' + pad(tzo % 60);
    };
  }

  /**
   * return UTC time of date
   * @param {Date} date
   * @returns {Date}
   */
  public static removeTimezone(date: Date) {
    if (date.getHours() === 0 && date.getMinutes() === 0 && date.getSeconds() === 0 && date.getMilliseconds() === 0) {
      // meaning the date was created from "dd MMM yyyy" format ex "25 Jul 2018"
      return date;
    } else {
      return new Date(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate(), date.getUTCHours(), date.getUTCMinutes());
    }
  }


  public static setToPlatformFormat() {
    Date.prototype['toPlatformFormat'] = function (withTime: boolean = false, clearTimezone: boolean = false) {
      return DateHandler.toString(this, withTime, clearTimezone);
    };
  }

  /**
   * return timestamp of date. If undefined returns null;
   * @param {Date} date
   * @returns {number | number}
   */
  public static getTime(date?: Date) {
    return date != null ? date.getTime() : 0;
  }

  public static getTimeStrings(date: Date, dateOptions?:any)  {
    return {
      time12String: date.toLocaleString('en-US', {hour: 'numeric', hour12: true, minute: 'numeric'}),
      time24String: moment().format('HH:mm:ss').replace(/[^0-9A-Za-z:]/g, ''),
    };
  }

}
